@if (isFavorite == true) {
  <span #favoriteTooltipContainer class="d-inline-block product-favorite-icon-container" data-bs-toggle="tooltip"
    data-bs-html="true" [attr.data-bs-title]="favoriteTooltipHtmlContent" data-bs-sanitize="true" data-bs-delay="200"
    data-bs-placement="auto">
    <i class="bi bi-trash c-pointer" (click)="isEnabled ? requestFavoriteRemove() : null"
    [attr.data-bs-title]="favoriteTooltipHtmlContent"></i>
  </span>
}
